var _circle, _circle2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 34,
    viewBox: "0 0 62 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 17,
    r: 15,
    fill: "#3B82F6",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 17,
    r: 16.75,
    stroke: "#3B82F6",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1074 9.63477C32.5835 9.68145 33.0461 9.76081 33.4951 9.87305C34.2639 10.0586 34.9204 10.2608 35.4639 10.4795L35.2051 13.084C34.4231 12.7328 33.6873 12.468 32.998 12.2891C32.3155 12.1035 31.6192 12.0107 30.9102 12.0107C30.1684 12.0108 29.5955 12.133 29.1914 12.3779C28.7872 12.6231 28.585 12.9911 28.585 13.4814C28.585 13.8724 28.6975 14.1872 28.9229 14.4258C29.1481 14.6643 29.4693 14.8697 29.8867 15.042C30.3042 15.2077 30.8045 15.3838 31.3877 15.5693C32.395 15.8874 33.2403 16.2387 33.9229 16.623C34.6118 17.0007 35.1291 17.4607 35.4736 18.0039C35.8248 18.5406 35.9999 19.2069 36 20.002C36 20.3996 35.9374 20.8342 35.8115 21.3047C35.6856 21.7685 35.4365 22.2095 35.0654 22.627C34.6943 23.0443 34.151 23.3885 33.4355 23.6602C33.0595 23.8007 32.6179 23.9027 32.1113 23.9688L32.2627 26.6426H30.3145L30.459 24.0537C29.944 24.0444 29.4154 23.9911 28.873 23.8887C28.2766 23.7826 27.7232 23.6534 27.2129 23.501C26.7026 23.3419 26.2982 23.1897 26 23.0439L26.2979 20.3408C26.7617 20.5661 27.2463 20.7746 27.75 20.9668C28.2534 21.1588 28.77 21.3144 29.2998 21.4336C29.8298 21.5528 30.3669 21.6123 30.9102 21.6123C31.5861 21.6123 32.1301 21.4799 32.541 21.2148C32.9518 20.9498 33.1572 20.5453 33.1572 20.002C33.1571 19.5847 33.0414 19.2498 32.8096 18.998C32.5777 18.7397 32.223 18.5113 31.7461 18.3125C31.2691 18.1071 30.659 17.8756 29.917 17.6172C29.1749 17.3588 28.5086 17.0668 27.9189 16.7422C27.3291 16.4108 26.8612 15.9929 26.5166 15.4893C26.1722 14.9858 26.0001 14.3431 26 13.5615C26 12.7929 26.1888 12.11 26.5664 11.5137C26.9441 10.9106 27.508 10.4395 28.2568 10.1016C28.8722 9.82094 29.6086 9.65651 30.4658 9.60449L30.3145 7H32.2627L32.1074 9.63477Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 19.84L51 13.84L54.0037 13.84L54.0037 9L61.8437 16.84L54.0037 24.68L54.0037 19.84L51 19.84Z",
    fill: "#3B82F6",
    fillOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8438 13.8399L10.8438 19.8399L7.84 19.8399L7.84 24.6799L9.34911e-08 16.8399L7.84 8.99993L7.84 13.8399L10.8438 13.8399Z",
    fill: "#3B82F6",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/headerLogo.3fb7568620bb8afe5e9e6b605538e2a5.svg";
export { ForwardRef as ReactComponent };